import { useState, useCallback } from 'react';

export const useOptimisticUpdate = <T extends { _id: string }>(initialData: T[]) => {
  const [data, setData] = useState<T[]>(initialData);

  const addOptimisticItem = useCallback((item: T) => {
    setData(prev => [item, ...prev]);
  }, [setData]);

  const removeOptimisticItem = useCallback((id: string) => {
    setData(prev => prev.filter(item => item._id !== id));
  }, [setData]);

  const updateItems = useCallback((items: T[]) => {
    setData(items);
  }, [setData]);

  return [data, addOptimisticItem, removeOptimisticItem, updateItems] as const;
};
